import { render, staticRenderFns } from "./ProtectedAreas.vue?vue&type=template&id=65554232&scoped=true&"
import script from "./ProtectedAreas.vue?vue&type=script&lang=js&"
export * from "./ProtectedAreas.vue?vue&type=script&lang=js&"
import style0 from "./ProtectedAreas.vue?vue&type=style&index=0&id=65554232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65554232",
  null
  
)

export default component.exports